export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-torso-5a8e2801021d226f77a87faff2eb820e.svg";